<div class="form-server-error-messages" *ngIf="bkForm" [ngClass]="{showing: bkForm.serverErrorMessages && bkForm.serverErrorMessages.length}">
    <div class="error error-text" *ngFor="let msg of bkForm.serverErrorMessages">{{msg}}</div>
</div>
